// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discounts-report .filter-properties>fieldset{margin:0 !important}.discounts-report .show-roomtype{width:140px}", ""]);
// Exports
module.exports = exports;
